import { adminClient } from './adminClient';

export interface AdminUser {
  id: number;
  name: string;
  email: string;
  role: string;
  role_label: string;
  is_active: boolean;
  last_login_at: string | null;
  created_at?: string;
}

export interface AdminShop {
  id: number;
  name: string;
  myshopify_domain: string;
  email: string;
  is_active: boolean;
  is_installed: boolean;
  plan_id: number | null;
  country_code: string | null;
  currency: string | null;
  installed_at: string | null;
  created_at: string | null;
  // detailed
  timezone?: string;
  locale?: string;
  shopify_plan_display_name?: string;
  trial_ends_at?: string | null;
  uninstalled_at?: string | null;
}

export interface AdminStats {
  shops: { total: number; active: number; inactive: number };
  ai_usage_30d: { requests: number; tokens: number; cost_usd: number };
  audits_30d: number;
  active_subscriptions: number;
  generated_at: string;
}

export interface PaginatedMeta {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
}

export const adminApi = {
  login: (email: string, password: string) =>
    adminClient.post<{ success: boolean; data: { token: string; admin_user: AdminUser } }>('/login', { email, password }),

  me: () =>
    adminClient.get<{ success: boolean; data: AdminUser }>('/me'),

  stats: () =>
    adminClient.get<{ success: boolean; data: AdminStats }>('/stats'),

  shops: {
    list: (page = 1, search = '') =>
      adminClient.get<{ success: boolean; data: AdminShop[]; meta: PaginatedMeta }>('/shops', {
        params: { page, per_page: 20, search },
      }),

    show: (id: number) =>
      adminClient.get<{ success: boolean; data: AdminShop }>(`/shops/${id}`),

    suspend: (id: number) =>
      adminClient.patch<{ success: boolean; data: { id: number; is_active: boolean } }>(`/shops/${id}/suspend`),

    reactivate: (id: number) =>
      adminClient.patch<{ success: boolean; data: { id: number; is_active: boolean } }>(`/shops/${id}/reactivate`),
  },

  users: {
    list: () =>
      adminClient.get<{ success: boolean; data: AdminUser[] }>('/users'),

    create: (data: { name: string; email: string; password: string; role: string }) =>
      adminClient.post<{ success: boolean; data: AdminUser }>('/users', data),

    delete: (id: number) =>
      adminClient.delete<{ success: boolean; data: null }>(`/users/${id}`),
  },
};
